import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { db, auth, functions } from '../firebase';
import { collection, onSnapshot, query, doc, getDoc, setDoc, updateDoc, where, getDocs, documentId, orderBy, limit } from 'firebase/firestore';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { ipfsGateway, FIREBASE_PROJECT_ID, API_BASE_URL, BASE_MAX_STAMINA, TOKEN_CONTRACT, TOKENS, tokenContracts, tokenDecimals, buildingConfigClient, ATOMIC_API_ENDPOINTS, itemTemplates, EMBLEM_NAMES, MASTER_ACCOUNT_WAX_ID, ADMIN_ACCOUNTS, STAKING_TIERS, VAULT_TIERS, VAULT_TOKEN_INFO, VAULT_TOKEN_VALUE, getUpgradeCostClient, Client, calculateDiminishedBoost, calculateMaxHp, calculateXpForNextLevel } from '../constants/gameConfig';
import characterImage from '../assets/firecat.png';
import placeholderImage from '../assets/equip.png';
function LastDailyLeaderboardPage() {
  const [lastDailyLeaderboard, setLastDailyLeaderboard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLastDailyLeaderboard = async () => {
      setLoading(true);
      try {
        const dateToQuery = new Date();
        // Go back 24 hours
        dateToQuery.setTime(dateToQuery.getTime() - (24 * 60 * 60 * 1000));

        // Format YYYY-MM-DD
        const year = dateToQuery.getFullYear();
        const month = String(dateToQuery.getMonth() + 1).padStart(2, '0');
        const day = String(dateToQuery.getDate()).padStart(2, '0');
        const yesterdayDocId = `${year}-${month}-${day}`;

        const docRef = doc(db, "daily_leaderboards", yesterdayDocId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setLastDailyLeaderboard(docSnap.data());
        } else {
          setLastDailyLeaderboard(null);
        }
      } catch (error) {
        // Safe error handling - prevents app crash
        console.warn("Daily Leaderboard load skipped:", error.code);
        setLastDailyLeaderboard(null);
      } finally {
        setLoading(false);
      }
    };
    fetchLastDailyLeaderboard();
  }, []);

  if (loading) {
    return <div style={{ textAlign: 'center', margin: '20px auto', color: '#aaa' }}>Loading Last Daily Leaderboard...</div>;
  }

  if (!lastDailyLeaderboard || !lastDailyLeaderboard.leaderboard || lastDailyLeaderboard.leaderboard.length === 0) {
    return (
      <div style={{ backgroundColor: 'rgba(0,0,0,0.7)', padding: '20px', borderRadius: '8px', maxWidth: '800px', margin: '20px auto', textAlign: 'center' }}>
        <h2>Last Daily Leaderboard</h2>
        <p style={{ color: '#aaa' }}>No data available for yesterday.</p>
      </div>
    );
  }

  const leaderboardDate = lastDailyLeaderboard.date?.toDate ? lastDailyLeaderboard.date.toDate().toLocaleDateString() : 'Unknown Date';

  return (
    <div style={{ backgroundColor: 'rgba(0,0,0,0.8)', padding: '20px', borderRadius: '8px', maxWidth: '800px', margin: '20px auto', border: '1px solid #444' }}>
      <h2 style={{ color: '#ff9800', textAlign: 'center' }}>Last Daily Leaderboard ({leaderboardDate})</h2>
      <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #555', color: '#888' }}>
            <th style={{ padding: '10px', textAlign: 'left' }}>Rank</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Wallet</th>
            <th style={{ padding: '10px', textAlign: 'right' }}>Points</th>
            <th style={{ padding: '10px', textAlign: 'right' }}>Reward</th>
          </tr>
        </thead>
        <tbody>
          {lastDailyLeaderboard.leaderboard.map((player, index) => (
            <tr key={player.waxId} style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px' }}>
                {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
              </td>
              <td style={{ padding: '10px' }}>{player.waxId}</td>
              <td style={{ padding: '10px', textAlign: 'right', color: '#00e5ff' }}>
                {Math.floor(player.dailyPoints || 0).toLocaleString()}
              </td>
              <td style={{ padding: '10px', textAlign: 'right' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
                  {player.nftImageUrls && player.nftImageUrls.length > 0 ?
                    player.nftImageUrls.map((imgUrl, idx) => (
                      <img key={idx} src={imgUrl} alt="Reward"
                        style={{ width: '30px', height: '30px', objectFit: 'contain', borderRadius: '4px', background: '#222', border: '1px solid #444' }}
                        title={`Asset ID: ${player.nftAssetIds?.[idx]}`} />
                    )) : <span style={{ fontSize: '12px', color: '#555' }}>-</span>
                  }
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default LastDailyLeaderboardPage;
